module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAANUlEQVR4nGNgwAb+//////9/rFJMWEXxgEGogfaAES34GBkZGRgYIILIbDgYhH7ADoZ50gAAy4sVBSLW6nQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/crosshair-white.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/crosshair-white.png
// module chunks = styles